module.exports = __webpack_public_path__ + "static/media/mail_chimp.c9076360.png";